<template>
  <button
    v-bind="$attrs"
    :class="
      twMerge(
        `${color}-button`,
        isRounded && 'rounded-full',
        'inline-flex h-9 w-9 items-center justify-center border transition-all outline-none hover:[box-shadow:none] hover:shadow-transparent focus:outline-none disabled:cursor-not-allowed',
        $attrs.class as string,
      )
    "
    :test_id="$attrs.test_id"
  >
    <span class="[&>svg]:size-4">
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
import type { ButtonColorType } from '@/shared/data/buttonColorTypes.ts'
import { twMerge } from 'tailwind-merge'

withDefaults(
  defineProps<{
    color?: ButtonColorType
    isRounded?: boolean
  }>(),
  {
    color: 'outline-gray',
    isRounded: true,
  },
)
</script>
